/**
 * The default layout of the applicant form's fields. RenderStep draws a step
 * in this layout, and the Field Sequence Admin screen starts its list from
 * it, so the Admin's "default order" is the order applicants already see.
 *
 * cp_form_field_mappings has no sort_order column, so fields arrive in
 * field-id order. The start uids are pinned to the top (in this exact order),
 * the Mauja/Khasara/Plot No. trio follows as one block, then come the fields
 * that are not pinned (in their existing relative order), and the end uids
 * close the step.
 */

export const START_BEFORE_KHASARA_BLOCK_UIDS = [
  "plot_owner_s_name",
  "unauthorized_layout_name",
  "name_of_service",
  "rl_application_type",
  "is_there_a_construction",
  "is_there_a_court_case_going_on_regarding_the_plot",
];

/**
 * Mauja / Khasara No. / Plot No. render together as one self-contained
 * sub-grid instead of through the generic per-field loop, because their
 * mobile stacking order (Manual Sub-Khasara glued directly under Khasara No.)
 * differs from their desktop row pairing (Plot No. + Manual Sub-Khasara
 * sharing a row) -- two layouts that cannot share one flat DOM order.
 */
export const KHASARA_BLOCK_UIDS = ["mauja", "khasara_no", "plot_no"];

/**
 * Fields drawn inside the Mauja/Khasara/Plot No. block when a service maps
 * them alongside the full trio, so they move with the block and are never
 * listed on their own.
 */
export const KHASARA_BLOCK_ABSORBED_UIDS = ["main_khasara_no", "manual_khasara_no"];

export const START_AFTER_KHASARA_BLOCK_UIDS: string[] = [];

export const PINNED_END_FIELD_UIDS = [
  "email_id",
  "mobile_no",
  "address",
  "submitted_by",
  "type_of_application_submitter",
];

/**
 * Fields the form never draws on their own. Main Khasara No. is only the
 * hidden value Khasara No.'s dropdown writes into (see RenderField), so it
 * has no place of its own in an order.
 */
export const NEVER_DRAWN_UIDS = ["main_khasara_no"];
